import React from 'react';

function Terms() {
  return (
    <div className="container">
      <article className="page">
        <h1>Terms &amp; Conditions</h1>
        <p className="updated">Last updated: April 7, 2026</p>

        <p>
          Welcome to <strong>Construction Calculator</strong>. By
          downloading, installing or using our mobile application or this
          website, you agree to be bound by the terms below. Please read them
          carefully.
        </p>

        <h2>1. Use of the app</h2>
        <p>
          Construction Calculator is provided for personal and professional
          use to assist with construction estimates and design ideas. You agree
          to use the app only for lawful purposes and in a way that does not
          infringe on the rights of others.
        </p>

        <h2>2. Accuracy of calculations</h2>
        <p>
          The calculators and estimates inside the app are intended as a guide.
          While we work hard to keep formulas accurate, we do not guarantee
          fitness for any specific project. Always verify critical figures with
          a qualified engineer or licensed professional before purchasing
          materials or starting work.
        </p>

        <h2>3. Intellectual property</h2>
        <p>
          All content, branding, designs, icons and code in the app and on
          this site are the property of the Construction Calculator team. You may not copy,
          redistribute or reverse-engineer any part of the product without
          written permission.
        </p>

        <h2>4. Advertisements</h2>
        <p>
          The app may display advertisements provided by third-party networks
          such as Google AdMob. We do not control the content of these ads
          and are not responsible for any third-party services they link to.
        </p>

        <h2>5. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, Construction Calculator and its developers are
          not liable for any direct, indirect, incidental or consequential
          damages arising out of your use of the app, including financial loss
          from incorrect estimates.
        </p>

        <h2>6. Changes to these terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the
          app after changes are posted means you accept the updated terms.
        </p>

        <h2>7. Contact</h2>
        <p>
          Questions about these terms? Email us at{' '}
          <a href="mailto:support@fairappsstore.com">support@fairappsstore.com</a>.
        </p>
      </article>
    </div>
  );
}

export default Terms;
